var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12.444,
    viewBox: "0 0 16 12.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59558",
    d: "M.889 7.111h14.222a.889.889 0 0 0 0-1.778H.889a.889.889 0 0 0 0 1.778z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59559",
    d: "M15.111 0H.889a.889.889 0 1 0 0 1.778h14.222a.889.889 0 0 0 0-1.778z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59560",
    d: "M.889 12.445h14.222a.889.889 0 0 0 0-1.778H.889a.889.889 0 0 0 0 1.778z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.c181ac8668dba57796d3ac8f114b7425.svg";
export { ForwardRef as ReactComponent };